/* © CNES */
import { useContext } from 'react';
import { ReactComponent as RocketLaunch } from '../../../assets/icons/rocket_launch.svg';
import { ConfigContext } from '../../../context/ConfigContext';
import './GetStarted.scss';

/**
 * Get Started Component.
 * @returns JSX.Element
 */
export const GetStarted = () => {
  const context = useContext(ConfigContext);

  return (
    <div
      className="frf-trigger-start-button"
      onClick={(e) => context.setIsGetStarted(true)}
      data-testid="getStarted-button"
    >
      <div
        className={'frf-start-icon'}
        style={{
          fill: '#fff',
        }}
      >
        <RocketLaunch />
      </div>
    </div>
  );
};
